import { RouteRecordRaw } from 'vue-router';
import { FormBuilderPage } from '@/features/FormBuilder';

export const routeName = 'EditarFormulario';

export const route: RouteRecordRaw = {
  path: '/edicao-formularios/:id',
  name: routeName,
  component: FormBuilderPage,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
